"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[628],{

/***/ 5427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Modal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var index_esm = __webpack_require__(6893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./src/themes/default/components/Modal/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  background-color: ",
        ";\n  color: #000;\n\n  border-radius: ",
        ";\n\n  max-width: ",
        ";\n  width: 100%;\n  margin: auto 0;\n  z-index: 1001;\n\n  transform: translateY(15%);\n  opacity: 0;\n\n  transition: opacity 0.3s, transform 0.3s;\n  will-change: opacity, transform;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 1000;\n\n  overflow: auto;\n\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: ",
        ";\n\n  background-color: rgba(0, 0, 0, 0.5);\n\n  opacity: 0;\n\n  transition: opacity 0.3s;\n  will-change: opacity;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 1000;\n\n  overflow: auto;\n\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 50px;\n\n  visibility: hidden;\n  transition: visibility 0.3s;\n\n  &.isVisible {\n    visibility: visible;\n\n    & ",
        " {\n      transform: translateY(0);\n      opacity: 1;\n    }\n\n    & ",
        " {\n      opacity: 1;\n    }\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: ",
        ";\n\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #000;\n  padding: ",
        ";\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-transform: uppercase;\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  color: ",
        ";\n  background-color: transparent;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: ",
        ";\n\n  & svg {\n    stroke-width: 3;\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}

const WrapperModal = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-663b6bd9-0"
})(_templateObject(), (p)=>p.theme.colors.background, (p)=>p.theme.borderRadius, (p)=>p.size ? p.theme.modal[p.size] : "100%");
const Overlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-663b6bd9-1"
})(_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.spacing.large;
});
const Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-663b6bd9-2"
})(_templateObject2(), WrapperModal, Overlay);
const Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-663b6bd9-3"
})(_templateObject3(), (p)=>p.theme.spacing.large, (p)=>p.theme.colors.border);
const Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-663b6bd9-4"
})(_templateObject4(), (p)=>p.theme.spacing.large);
const Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-663b6bd9-5"
})(_templateObject5(), (p)=>p.theme.font.medium, (p)=>p.theme.colors.textPrimary);
const ButtonClose = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-663b6bd9-6"
})(_templateObject6(), (p)=>p.theme.colors.textPrimary, (p)=>p.theme.font.xLarge);

;// CONCATENATED MODULE: ./src/themes/default/components/Modal/index.tsx




const Modal = (param)=>{
    let { modal , handleClose  } = param;
    const { component , config  } = modal || {};
    const { onClose , title , size , props  } = config || {};
    function handleOnClose() {
        for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
            params[_key] = arguments[_key];
        }
        handleClose();
        if (onClose) onClose(...params);
    }
    const isVisible = (0,react.useMemo)(()=>{
        return !!modal && !(modal === null || modal === void 0 ? void 0 : modal.isClosed);
    }, [
        modal
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        className: isVisible ? "isVisible" : "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay, {
                onClick: handleClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperModal, {
                size: size,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                        children: [
                            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonClose, {
                                onClick: handleClose,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiX */.q5L, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                        children: !!component && /*#__PURE__*/ (0,react.createElement)(component, {
                            onClose: onClose ? handleOnClose : null,
                            handleClose,
                            ...props || {}
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Modal = (Modal);


/***/ })

}]);